import keys from '@debbie/common/dist/cache/keys.js';
import { parseOrStr } from '@debbie/common/dist/util/index.js';
import { casesEntity, ensureCaseLoaded, } from '@debbie/cortex/dist/cases/index.js';
import { customersEntity, ensureCustomerLoaded, } from '@debbie/cortex/dist/customers/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { Button, Modal, SearchInput } from '../index.js';
import { getDescriptor } from './registries.js';
const ErrorModal = (props) => {
    const [selectedRKIError, setSelectedRKIError] = useState(null);
    const [registeringError, setRegisteringError] = useState(false);
    // The reasons below are RKI-specific; the error action is currently only
    // enabled for RKI. If another registry enables this action, move the list
    // into the registry descriptor.
    const searchError = (q) => {
        return [
            'Vi kunne ikke identificere din skyldner',
            'Personen oplyses uden fast bopæl',
            'Udenlandsk adresse er ikke fundet',
            'Personen er død',
            'Debitor oplyses uden fast bopæl',
            'Brev kunne ikke leveres',
            'Personen er under 18 år (CPR)',
            'Indberettet 2 gange (DBL)',
            'Skyldner er afgået ved døden (DØD)',
            'Forkert kreditor (FIN)',
            'Oplysningerne var ikke korrekte (FJL)',
            'Fundamentsdato er for gammel (FUN)',
            'Gældssanering-al gæld bortfald (GAL)',
            'Brev til skyldner kan ikke afleveres (PTI)',
            'Sagen genoptaget ved retten (SGO)',
            'Der er strid i sagen (STR)',
            'Tvangsauktion er aflyst (TAF)',
            'Tvangsakkord er fyldestgjort (TFY)',
            'Varen er taget retur (VTT)',
        ]
            .filter((t) => t.toLowerCase().indexOf(q.toLowerCase()) !== -1 || q.length === 0)
            .map((t) => ({
            key: t,
            heading: t,
            returnData: t,
        }));
    };
    const registerError = async () => {
        try {
            setRegisteringError(true);
            if (!props.rkiReferenceId) {
                throw 'Intet rkiReferenceId valgt.';
            }
            if (!selectedRKIError) {
                throw 'Ingen fejl valgt.';
            }
            if (!props.userId) {
                throw 'Kunne ikke finde debitor.';
            }
            if (!props.caseId) {
                throw 'Kunne ikke finde sags id.';
            }
            const errorAction = getDescriptor(props.registry).actions.error;
            if (!errorAction) {
                throw 'Fejlregistrering understøttes ikke af dette register.';
            }
            await errorAction.call(props.userId, props.caseId, props.rkiReferenceId, selectedRKIError);
            q.invalidate(keys.write.modify(casesEntity, props.caseId));
            q.invalidate(keys.write.modify(customersEntity, props.customer.customerId));
            await ensureCaseLoaded(props.caseId);
            await ensureCustomerLoaded(props.customer.customerId);
            props.toggleErrorOpenModal();
        }
        catch (error) {
            console.error(error);
            const err = error?.message ? parseOrStr(error.message) : error;
            alert(typeof err === 'object' && 'description' in err ? err.description : err);
        }
        setRegisteringError(false);
    };
    return (React.createElement(Modal, { header: "Registr\u00E9r fejl", onToggle: props.toggleErrorOpenModal, maxWidth: "350px" },
        React.createElement(SearchInput, { onSelect: (result) => {
                setSelectedRKIError(result);
            }, static: selectedRKIError, onRemoveStatic: () => {
                setSelectedRKIError(null);
            }, searchDelay: 0, forceOpen: true, searchAll: searchError, placeholder: "V\u00E6lg fej\u00E5rsag" }),
        React.createElement(Button, { disabled: !selectedRKIError, loading: registeringError, block: true, onClick: registerError }, "Registr\u00E9r fejl")));
};
export default ErrorModal;
//# sourceMappingURL=ErrorModal.js.map